import { render, staticRenderFns } from "./ListAssociados.vue?vue&type=template&id=bc30011a&scoped=true"
import script from "./ListAssociados.vue?vue&type=script&lang=js"
export * from "./ListAssociados.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/listCard.css?vue&type=style&index=0&id=bc30011a&prod&scoped=true&lang=css&external"
import style1 from "./ListAssociados.vue?vue&type=style&index=1&id=bc30011a&prod&lang=scss"
import style2 from "./ListAssociados.vue?vue&type=style&index=2&id=bc30011a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc30011a",
  null
  
)

export default component.exports